import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const submitPricingOffer = ({
  packageId,
  couponCode,
}: {
  packageId: string;
  couponCode?: string;
}): Promise<void> => {
  const params: Record<string, string> = {};

  if (couponCode) {
    params['couponCode'] = couponCode;
  }

  return companyCreationAxiosInstance.post(
    `v1/customer/pricing-packages/${packageId}/offer`,
    { params }
  );
};
